module.exports = __webpack_public_path__ + "img/metaImage_02.6c386404.png";